import { z } from 'zod'

const doorRefSchema = z.object({ id: z.string(), name: z.string() })

export const ButterflyConnectionSchema = z.object({
  authorizationCode: z.string().min(1, 'Authorization code is required'),
  shouldAutoAssignApartmentDoorVisitor: z.boolean(),
  visitorPermissionDoors: z.array(doorRefSchema),
})

export type ButterflyConnectionFormValues = z.infer<typeof ButterflyConnectionSchema>

export const butterflyDefaultValues: ButterflyConnectionFormValues = {
  authorizationCode: '',
  shouldAutoAssignApartmentDoorVisitor: false,
  visitorPermissionDoors: [],
}
